import React from "react";
import LoginForm from "../components/organisms/LoginForm";

const LoginPage = ({ onLogin }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <LoginForm onLogin={onLogin} />
    </div>
  );
};

export default LoginPage;
